export default {"src":"/_next/static/media/down.75fb7b70.svg","height":9,"width":17};